/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSupportAgentIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-support-agent"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 21.8Q11.45 21.8 11.07 21.41Q10.7 21.02 10.7 20.48Q10.7 19.93 11.09 19.55Q11.47 19.18 12.03 19.18L19.18 19.18Q19.18 19.18 19.18 19.18Q19.18 19.18 19.18 19.18L19.18 11.93Q19.18 8.95 17.07 6.88Q14.97 4.8 12 4.8Q9.03 4.8 6.94 6.88Q4.85 8.95 4.85 11.93L4.85 17.02Q4.85 17.57 4.46 17.96Q4.08 18.35 3.52 18.35L3.52 18.35Q2.58 18.35 1.89 17.66Q1.2 16.98 1.2 16.02L1.2 14.03Q1.2 13.45 1.48 12.96Q1.75 12.47 2.23 12.15L2.3 10.97Q2.52 9.1 3.38 7.5Q4.22 5.9 5.53 4.71Q6.83 3.52 8.47 2.85Q10.13 2.17 12 2.17Q13.88 2.17 15.54 2.85Q17.2 3.52 18.5 4.7Q19.8 5.88 20.65 7.47Q21.5 9.07 21.73 10.95L21.8 12.07Q22.27 12.38 22.54 12.85Q22.8 13.32 22.8 13.88L22.8 16.18Q22.8 16.75 22.54 17.23Q22.27 17.7 21.8 18L21.8 19.18Q21.8 20.27 21.04 21.04Q20.27 21.8 19.18 21.8ZM9 14.82Q9 14.82 8.72 14.82Q8.45 14.82 8.06 14.45Q7.67 14.07 7.67 13.53Q7.67 12.97 8.06 12.59Q8.45 12.2 9 12.2Q9.55 12.2 9.93 12.59Q10.3 12.97 10.3 13.53Q10.3 14.07 9.93 14.45Q9.55 14.82 9 14.82ZM15.03 14.82Q15.03 14.82 14.75 14.82Q14.47 14.82 14.09 14.45Q13.7 14.07 13.7 13.53Q13.7 12.97 14.09 12.59Q14.47 12.2 15.03 12.2Q15.57 12.2 15.95 12.59Q16.32 12.97 16.32 13.53Q16.32 14.07 15.95 14.45Q15.57 14.82 15.03 14.82ZM5.72 12.95Q5.53 10.05 7.38 7.89Q9.22 5.72 12.05 5.72Q14.47 5.72 16.24 7.34Q18 8.95 18.4 11.38Q16.15 11.35 14.18 10.34Q12.2 9.32 11 7.45Q10.43 9.38 9.01 10.79Q7.6 12.2 5.72 12.95Z" fill={color} />
    </svg>
  );
}
